var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotPointTarget = function SvgDotPointTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3.5,
    fill: "inherit"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 0.5,
    fill: "inherit"
  })));
};
export default SvgDotPointTarget;